import { AwaitingFundsIllustrationSVG } from '../../../svgComponents/awaitingFundsIllustrationSVG';
import messages from './AwaitingFundsView.messages';
import { StateView } from '../../pageStructure/stateView';
import { FormattedMessage } from 'react-intl';

export const AwaitingFundsView = () => {
    return (
        <StateView
            image={<AwaitingFundsIllustrationSVG />}
            headerMessage={<FormattedMessage {...messages.title} />}
            descriptionMessage={<FormattedMessage {...messages.subtitle} />}
        />
    );
};
